export default "__VITE_ASSET__01747542__"